import _ from "lodash"
import Patch from "@shared/models/patch-updater"
import createNarrative from "../create-narrative"

export const COURSE_UPDATE_STANDARD_SET_IDS = {
  name: "COURSE_UPDATE_STANDARD_SET_IDS",

  params: {
    courseId: "string",
    planbookId: { type: "string", optional: true },
    standardSetIds: { type: "array", items: { type: "string" } },
  },

  patches(payload) {
    let relationships = _.map(payload.standardSetIds, (id) => {
      return { id: id, type: "standard-set" }
    })

    let patch = Patch.create("course", payload.courseId)
      .set("relationships.standardSets.data", relationships)
      .set("attributes.standardSetIds", payload.standardSetIds).patch
    return [patch]
  },

  undoPatches: null,

  narrative(payload) {
    return createNarrative({
      context: {
        standardSetIds: payload.standardSetIds,
      },
    })
  },
}

export default COURSE_UPDATE_STANDARD_SET_IDS
